export default function WhatsAppFloat() {
  return (
    <a
      href="https://wa.me/447481624940?text=Hola%20Novacréditos,%20deseo%20información%20confidencial%20sobre%20sus%20servicios%20de%20crédito."
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contacto por WhatsApp"
      className="fixed bottom-6 right-6 z-[9999] bg-[#25d366] rounded-full p-4 shadow-lg hover:scale-110 transition-transform duration-300 cursor-pointer group"
    >
      <div className="relative">
        <i className="ri-whatsapp-fill text-white text-4xl"></i>
        <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full animate-pulse"></span>
      </div>
      <div className="absolute right-full mr-4 top-1/2 -translate-y-1/2 bg-slate-800 text-white px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
        ¿Necesitas ayuda? Escríbenos
        <div className="absolute top-1/2 -translate-y-1/2 -right-2 w-0 h-0 border-t-8 border-t-transparent border-b-8 border-b-transparent border-l-8 border-l-slate-800"></div>
      </div>
    </a>
  );
}